import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';

@Component({
  name: 'bpc-subscription-checklist',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class SubscriptionChecklist extends mixins(AbstractField) {
  @Prop([Object, Array]) readonly value: AnyEntity;
  @Prop({ type: Boolean, default: false }) readonly single: boolean;

  public loading = false;
  public options: object[] = [];

  mounted() {
    if (!this.value) {
      this.model = {};
    } else {
      const contactIds = Object.keys(this.model);
      const contacts = contactIds.map(id => {
        return { id: id };
      });
      this.getOptions(contacts);
    }
  }

  get path(): string {
    return this.$bpcApiRouteHelper.getEntityPath('contact') + '/contact-subscriptions';
  }

  get model(): AnyEntity {
    return this.value;
  }
  set model(val: AnyEntity) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }
  updateModel() {
    this.$emit('input', this.value);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, this.value);
      });
    }
  }
  extendHandleEvent(eventName: string, event: any, val: any) {
    this.getOptions(val);
  }
  public getOptions(val = null): void {
    if (val) {
      let forEntity: string;
      switch (true) {
        case 'booking_type' in this.formModel:
          forEntity = 'booking';
          break;
        case 'activity_session_id' in this.formModel:
          forEntity = 'activitySession';
          break;
      }
      this.loading = true;
      let contactIds;
      if (Array.isArray(val)) {
        contactIds = val.map(v => {
          return v['id'];
        });
      } else {
        contactIds = [val['id']];
      }
      this.$bpcApi
        .get(this.path, { params: { contactIds: contactIds, forEntity: forEntity } })
        .subscribe(
          (res: BPCGenericApiResponse) => {
            this.options = res.data;
            this.calculateModel();
          },
          error => {
            console.log(error);
          },
          () => {
            this.loading = false;
          },
        );
    }
  }

  public calculateModel() {
    this.model = Object.keys(this.model || {}).reduce((newModel, key) => {
      const option = this.options.find(option => option['contact'].id === key);
      if (option) {
        newModel[key] = this.model[key];
      }
      return newModel;
    }, {});
  }

  get thereAreSubscriptions() {
    if (this.options) {
      for (const option of this.options) {
        if (option['subscriptions'].length > 0) {
          return true;
        }
      }
    }
    return false;
  }
}
